<template>
  <b-container>
    <h1 v-translate>Bulk Quotes</h1>
    <bulk-quotes-list />
  </b-container>
</template>
<script>
import BulkQuotesList from '@/components/BulkQuotesList'

export default {
  name: 'BulkQuotesPage',
  components: {
    BulkQuotesList
  }
}
</script>
